var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailSecHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0796 7.03928V0H6.92045V7.03922H0V30H6.92045H8.7027H10.8117H19.1883H21.2974H23.0796H30V7.03928H23.0796ZM6.92045 28.2178H1.78225V8.82158H6.92045V28.2178ZM14.1089 28.2178H12.594V24.1093H14.1089V28.2178ZM17.4061 28.2178H15.8912V24.1093H17.4061V28.2178ZM21.2974 7.03922V28.2178H19.1883V22.3271H10.8117V28.2178H8.7027V7.03928V1.78225H21.2973V7.03922H21.2974ZM28.2178 28.2178H23.0796V8.82158H28.2178V28.2178Z",
    fill: "#48C2C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8051 3.65308V5.50464H14.1944V3.65308H12.4121V9.13845H14.1944V7.28688H15.8051V9.13845H17.5873V3.65308H15.8051Z",
    fill: "#48C2C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5947 11.002H10.8125V13.1008H12.5947V11.002Z",
    fill: "#48C2C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8916 11.002H14.1094V13.1008H15.8916V11.002Z",
    fill: "#48C2C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1895 11.002H17.4072V13.1008H19.1895V11.002Z",
    fill: "#48C2C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5947 14.7251H10.8125V16.824H12.5947V14.7251Z",
    fill: "#48C2C5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8916 14.7251H14.1094V16.824H15.8916V14.7251Z",
    fill: "#48C2C5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1895 14.7251H17.4072V16.824H19.1895V14.7251Z",
    fill: "#48C2C5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5947 18.4482H10.8125V20.5471H12.5947V18.4482Z",
    fill: "#48C2C5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8916 18.4482H14.1094V20.5471H15.8916V18.4482Z",
    fill: "#48C2C5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1895 18.4482H17.4072V20.5471H19.1895V18.4482Z",
    fill: "#48C2C5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5401 11.002H24.7578V13.1008H26.5401V11.002Z",
    fill: "#48C2C5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5401 14.7251H24.7578V16.824H26.5401V14.7251Z",
    fill: "#48C2C5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5401 18.4482H24.7578V20.5471H26.5401V18.4482Z",
    fill: "#48C2C5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5401 22.2427H24.7578V24.3416H26.5401V22.2427Z",
    fill: "#48C2C5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24123 11.002H3.45898V13.1008H5.24123V11.002Z",
    fill: "#48C2C5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24123 14.7251H3.45898V16.824H5.24123V14.7251Z",
    fill: "#48C2C5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24123 18.4482H3.45898V20.5471H5.24123V18.4482Z",
    fill: "#48C2C5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24123 22.2427H3.45898V24.3416H5.24123V22.2427Z",
    fill: "#48C2C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailSecHotel);
export default __webpack_public_path__ + "static/media/detail-sec-hotel.6d9afaf7907c4a8365ed2f8b46717d79.svg";
export { ForwardRef as ReactComponent };